import React, { Component } from "react";
import Loader from "../../Shared/Loader/loader";
import SolutionCards from "./SolutionCards";
import SolutionDetail from "./SolutionDetail";
import { Link } from "react-router-dom";
import { PageContainer, Content } from "../../Drawer/PageContainer";
import NoRecord from "../../Display/NoRecord";
import UseSolutionTemplate from "./UseSolutionTemplate";
import AllLibraryAppsByCategory from "./AllLibraryAppsByCategory";
import Scrollable from "../../Shared/Edit/Scrollable";

class SolutionCollection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Solutions: [...this.props.Data],
            selectedSolution: { id: "", },
            UseSolutionTemplate: { id: "", },
            solutionFilter: "",
            loading: true,
        };
    }

    componentDidMount = async () => {
        await this.SetData(this.props);
    };

    componentWillReceiveProps = async (props) => {
        await this.SetData(props);
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }

        return (
            <PageContainer>
                <Content>
                    <div className="py-2 px-1 m-0 row h-90">
                        {this.state.selectedSolution.id !== "" && (
                            <SolutionDetail
                                isShowFromRuntime={this.props.isShowFromRuntime}
                                UseSolutionTemplate={this.handleShowUseSolutionTemplate}
                                onBack={this.handleBack}
                                userRole={this.props.userRole}
                                onCreate={this.props.onCreate}
                                solution={this.state.selectedSolution}
                            />
                        )}

                        {this.state.UseSolutionTemplate.id !== "" && (
                            <UseSolutionTemplate
                                user={this.props.user}
                                organization={this.props.organization}
                                onClose={this.handleCloseUseSolutionTemplate}
                                solution={this.state.UseSolutionTemplate}
                            />
                        )}

                        {this.state.selectedSolution.id === "" && (
                            <>
                                <div className="mt-2 mb-5 col-12">
                                    <div className="m-0 row">
                                        <div className="col mt-2">
                                            <div className="page-header">
                                                App Library
                                            </div>
                                        </div>
                                        <div className="col-5 pe-2 me-1 mb-3">
                                            <input
                                                type="text"
                                                value={this.state.solutionFilter}
                                                onClick={this.navigateToAllApps}
                                                onChange={this.filterSolutions}
                                                placeholder="&#xf002; &nbsp; Search app"
                                                className="form-control unicode"
                                            />
                                        </div>
                                    </div>
                                    <div className="m-0 row">
                                        <div className={`col ${this.props.selectedTemplate.templateName === "All Apps"? "mt-2":"my-2"}`}>
                                            <div className="page-header">
                                                {this.props.selectedTemplate.templateName}
                                            </div>
                                        </div>
                                    </div>

                                <Scrollable>
                                    <div className="row">
                                        {
                                            this.props.selectedTemplate.templateName === "All Apps" &&
                                            this.state.solutionFilter.trim() === "" &&
                                            <div className="mt-8 ps-0">
                                            <AllLibraryAppsByCategory
                                                tags={this.props.tags}
                                                user={this.props.user}
                                                userRole={this.props.userRole}
                                                projects={this.state.Solutions}
                                                accessedFromWorkspace={this.props.isShowFromRuntime}
                                                onProjectSelect={this.handleSelectedTemplate}
                                                onUseAppClick={
                                                    this.props.isShowFromRuntime ?
                                                    this.props.onCreate
                                                    :
                                                    this.handleShowUseSolutionTemplate
                                                }
                                                onSeeAllClick={this.props.onSeeAllClick}
                                            />
                                            </div>
                                        }
                                        {
                                            (
                                                this.props.selectedTemplate.templateName !== "All Apps" ||
                                                this.state.solutionFilter.trim() !== ""
                                            ) &&
                                            this.state.Solutions.length !== 0 &&
                                            this.state.Solutions.map((solution, index) => (
                                                <div className="mb-4 col-lg-6 col-xl-4" key={solution.id}>
                                                    <SolutionCards
                                                        UseSolutionTemplate={this.handleShowUseSolutionTemplate}
                                                        selectSolutions={() => this.handleSelectedTemplate(solution)}
                                                        solution={solution}
                                                        userRole={this.props.userRole}
                                                        user={this.props.user}
                                                        onCreate={this.props.onCreate}
                                                        isShowFromRuntime={this.props.isShowFromRuntime}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </Scrollable>
                                </div>
                                {this.state.Solutions.length === 0 && (
                                    <div className="mb-4 col">
                                        <NoRecord message="No apps found" />
                                    </div>
                                )}
                                <div className="bottom-0 p-2 d-none col position-fixed bg-lighter">
                                    Don't find what you're looking for?
                                    <Link
                                        to={
                                            "/" +
                                            localStorage.getItem(
                                                "selectedOrganization"
                                            )
                                        }
                                    >
                                        <span className="link">

                                            create you app from scratch
                                        </span>
                                    </Link>
                                    |
                                    <span className="link">

                                        Collab with Alice
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                </Content>
            </PageContainer>
        );
    }

    SetData = async (props) => {
        let SolutionsData = [...props.Data];
        let solutionFilter = (
            props.selectedTemplate.templateName === this.props.selectedTemplate.templateName ?
            this.state.solutionFilter :
            ""
        );
        if (props.selectedTemplate.templateName !== "All Apps") {
            if (props.selectedTemplate.templateName === "Super App") {
                SolutionsData = SolutionsData.filter(
                    (item) => item.isSuperApp === true
                );
            } else if (props.selectedTemplate.templateName === "Featured") {
                SolutionsData = SolutionsData.filter(
                    (item) => item.isFeaturedApp === true
                );
            } else {
                SolutionsData = SolutionsData.filter((item) =>
                    item.tag.includes(props.selectedTemplate.templateName)
                );
            }
        }

        this.setState({
            Solutions: SolutionsData,
            selectedSolution: { id: "", },
            UseSolutionTemplate: {
                id: "",
            },
            loading: false,
            solutionFilter,
        });
    };

    handleSelectedTemplate = (dataItem) => {
        this.setState({
            selectedSolution: dataItem,
        });
    };

    handleShowUseSolutionTemplate = (dataItem) => {
        this.setState({
            UseSolutionTemplate: dataItem,
        });
    };

    handleCloseUseSolutionTemplate = () => {
        this.setState({
            UseSolutionTemplate: {
                id: "",
            }
        });
    };

    handleBack = () => {
        this.setState({
            selectedSolution: {
                id: "",
            },
        });
    };

    filterSolutions = (e) => {
        let SolutionsData = [...this.props.Data];
        debugger;
        if (e.target.value.trim() !== "") {
            SolutionsData = SolutionsData.filter((item) =>
                item.name.toLowerCase().includes(e.target.value.trim().toLowerCase())
            );
        }
        if (this.props.selectedTemplate.templateName !== "All Apps") {
            if (this.props.selectedTemplate.templateName === "Super App") {
                SolutionsData = SolutionsData.filter(
                    (item) => item.isSuperApp === true
                );
            } else if (
                this.props.selectedTemplate.templateName === "Featured"
            ) {
                SolutionsData = SolutionsData.filter(
                    (item) => item.isFeaturedApp === true
                );
            } else {
                SolutionsData = SolutionsData.filter((item) =>
                    item.tag.includes(this.props.selectedTemplate.templateName)
                );
            }
        }

        this.setState({
            Solutions: SolutionsData,
            solutionFilter: e.target.value,
        });
    };

    navigateToAllApps = () => {
        if (this.state.solutionFilter.trim() === "") {
            this.props.onSeeAllClick({
                templateName: "All Apps"
            });
        }
    }
}

export default SolutionCollection;
